import { Dialog, Flash, Form, Instance, Objekt, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminUserService } from '@services/adminUserService';
import { LanguageService } from '@services/languageService';
import { UserService } from '@services/userService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminUsersIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminUserService',
        'languageService',
        'userService',
    ] as const;

    private table!: Table;
    private dialog: Dialog;
    private flash: Flash;

    constructor(
        instances: Instance,
        private adminUserService: AdminUserService,
        private languageService: LanguageService,
        private userService: UserService,
    ) {
        super(instances);

        this.dialog = instances.dialog;
        this.flash = instances.flash;
    }

    protected override _initToolbarButtons(): void {
        this.helper.fabButton('.btn-users-invite', this.dom, () => {
            this._inviteUserDialog();
        });

        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-users-new', this.dom, () => {
            this.adminUserService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminUserService,
            {
                entityKey: 'users',
                fetchData: (params) =>
                    this.adminUserService.getAll(params),
                extraParams: (params) => params.set('query', this.query),
            },
            [
                {
                    style: () => ['share'],
                    click: this._connectionUser.bind(this),
                },
                {
                    style: () => [
                        'edit',
                        this.languageService.translate('buttons.edit'),
                    ],
                    click: (user) => {
                        this.adminUserService
                            .editDialog(user, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }

    private _inviteUserDialog(): void {
        this.dialog
            .loadTemplate('/client/v1/users/invite.html')
            .then((dialogKnot) => {
                const form = new Form(dialogKnot);
                form.on('submit', (formData: Objekt) => {
                    form.lock();
                    const userData = formData.get<Objekt>('user');
                    this.userService.invite(userData).then(
                        (response) => {
                            this.flash.addMessage(response.get('message'));
                            this.dialog.close();
                        },
                        (response) => {
                            this.flash.addMessage(response.get('message'));
                            form.unlock();
                            form.setErrors(response.get<Objekt>('errors'));
                        },
                    );
                });

                form.on('reset', () => {
                    this.dialog.close();
                });

                this.dialog.open();
            });
    }

    private _connectionUser(user: Objekt): void {
        // manage organization_users table
    }
}

export const adminUsersIndexController = app.controller(
    'adminUsersIndexController',
    AdminUsersIndexController,
);
